import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {IUser, User} from "../../features/users/user";
import {IIdentityDetail, IdentityDetail} from '../../features/users/identity-detail';
import {EntityList} from '../../wappy/domain/entity-list';

interface IUserPagedResult {
  listObject: IUser[];
  totalRows?: number;
}

export interface UserIdentitySnapshotBackfillResult {
  createdSnapshots: number;
  missingKeycloakUserIds: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiUsersService extends ApiService{
  private readonly url = `${environment.api.baseUrl}/users`;

  getMe(): Observable<User> {
    const url = `${this.url}/me`;
    return this.get<IUser>(url).pipe(
        map((user: IUser) => new User(user))
    );
  }

  getUsers(filters: string | null = null): Observable<EntityList<User>> {
    const url = filters
      ? `${this.url}?filterBase64=${encodeURIComponent(filters)}`
      : this.url;
    return this.get<IUserPagedResult>(url).pipe(
        map(result => new EntityList<User>({
          items: result.listObject.map(userData => new User(userData)),
          totalRows: result.totalRows ?? 0,
        }))
    );
  }

  getIdentityDetail(
    subjectType: 'user' | 'prospect',
    subjectId: string
  ): Observable<IdentityDetail> {
    return this.get<IIdentityDetail>(
      `${this.url}/${subjectType}/${subjectId}`
    ).pipe(map(data => new IdentityDetail(data)));
  }

  backfillIdentitySnapshots(): Observable<UserIdentitySnapshotBackfillResult> {
    return this.post<UserIdentitySnapshotBackfillResult>(
        `${this.url}/identity-snapshots/backfill`,
        {}
    );
  }
}
